var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.service_id_list),function(service_id){return _c('vs-chip',{key:service_id},[_vm._v(_vm._s(_vm.getServiceIdToName(service_id)))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }